import axios from 'axios';
import store from '../store';
import Cookies from 'js-cookie';
import { uiActions } from '../store/ui-slice';
// form data
let api_url = store.getState().ui.api_url;
/**********************************************/
/* Name: setCookiesServices */
/* Description: setCookiesServices */
/**********************************************/
export const setCookiesServices = (nationalID, id) => {
  const expiresData = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000); // 1 days

  if (nationalID) {
    Cookies.set('nationalID', nationalID, {
      path: '/',
      expires: expiresData,
    });
  }
  if (id) {
    Cookies.set('id', id, {
      path: '/',
      expires: expiresData,
    });
  }
};

/**********************************************/
/* Name: getStudentDataService Request */
/* Description: getStudentDataService Request */
/**********************************************/
export const getStudentDataService = async (nationalID) => {
  const data = {
    nationalID,
  };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/getStudent`,
      data
    );
    // set cookies
    setCookiesServices(nationalID, response.data._id);
    return { status: 'success', user: response.data };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: reGetStudentDataService Request */
/* Description: reGetStudentDataService Request */
/**********************************************/
export const reGetStudentDataService = async () => {
  const nationalID = Cookies.get('nationalID');
  const data = {
    nationalID,
  };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/getStudent`,
      data
    );
    // set redux
    store.dispatch(uiActions.setStudentData(response.data.result));
    store.dispatch(uiActions.setStudentID(response.data._id));
    store.dispatch(uiActions.setStudentObj(response.data.studentData));
    return { status: 'success', user: response.data };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: completeStudentData Request */
/* Description: completeStudentData Request */
/**********************************************/
export const completeStudentDataService = async (data, id) => {
  try {
    const response = await axios.patch(
      `${api_url}/api/v1/students/completeStudentData/${id}`,
      data
    );
    await reGetStudentDataService();
    return { status: 'success', message: response.data.message };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: getQuizService */
/* Description: getQuizService */
/**********************************************/
export const getQuizService = async () => {
  const id = Cookies.get('id');
  try {
    const response = await axios.get(
      `${api_url}/api/v1/students/question/${id}`
    );
    return { status: 'success', questionsArray: response.data.randomQuestions };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: submitQuizService */
/* Description: submitQuizService */
/**********************************************/
export const submitQuizService = async (data) => {
  const id = Cookies.get('id');
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/question/${id}`,
      data
    );
    return { status: 'success', message: response.data.message };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: deleteStudentData */
/* Description: deleteStudentData */
/**********************************************/
const deleteStudentData = async (id) => {
  try {
    const response = await axios.delete(
      `${api_url}/api/v1/students/deleteStudent/${id}`
    );
    return { status: 'success', message: response.data.message };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
